const Footer = () => {
  return (
    <footer className="py-4 px-6 bg-[#0B1120] text-gray-400 text-sm flex justify-center items-center">
      <p className="text-center">
        &copy; {new Date().getFullYear()} NeuroHubs. All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
